import React from 'react'
import styled from 'styled-components'
import { Grid, Paper, TextField } from '@material-ui/core'
import { Checkbox } from '@progress/kendo-react-inputs'
import { Field } from '@progress/kendo-react-form'

export const SafeTextArea = ({ validationMessage, valid, ...other }) => (<TextField {...other} />) // we filter out props, that are not relevant for TextField to avoid react-dom warnings

export const SafeCheckbox = ({ validationMessage, valid, touched, visited, modified, ...other }) => (<Checkbox {...other} />) // we filter out props, that are not relevant for Checkbox to avoid react-dom warnings

export const InnerGrid = styled(Grid)`
    /*border: 1px solid red;*/
`

export const StyledPaper = styled(Paper)`
    margin-bottom: 20px;
    padding: 10px;
`

export const Headline = styled.span`
    display: block;
    margin-bottom: 10px;
    font-size: 20px;
    color: #555;
`
export const Placeholder = styled.div`
    height: ${props => props.height ? props.height : '20px'};
`

export const ButtonBar = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`

export const GridWrapper = styled.div`
    margin-top: 20px;
    background-color: #f2f2f2;
    padding: 0 10px 10px 10px;
    border-radius: 4px;
`

export const FullsizedField = styled(Field)`
    width: 100%;
`

export const FullsizedTextInput = styled(SafeTextArea)`
    margin-top: 5px !important;
`





// WEBPACK FOOTER //
// ./src/components/styled/FormComponents.js